enum UserFieldId {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  PhoneNumber = 'phoneNumber',
  Company = 'companyId',
  CompanyAlias = 'companyAlias',
  Roles = 'roles',
  Trades = 'trades',
  Teams = 'teams',
  DefaultTeams = 'defaultTeams',
  Tags = 'tags',
  AccountType = 'accountType',
  AvatarUrl = 'avatarUrl',
  Initials = 'initials',
  GlobalRole = 'globalRole',
  AccountPosition = 'accountPosition',
  AssignedCodes = 'assignedCodes',
  EmployeeId = 'employeeId',
}

export default UserFieldId
